/* eslint-disable max-len -- need */
const calculateTransferpoints = (inputValue, transferRateMultipliers, data) => {
  /**
     * final values depends on
     * 1. User input
     * 2. transferRate for that industry (airline/hotel/other)
     * 3. transferRateMultiplier  for that industry
     */
  const transferRate = data?.transferRate;
  const partner = data?.partner;
  let miles = null;
  if (partner && transferRate && inputValue !== '' && Number(inputValue) >= 0 && transferRateMultipliers[partner]) {
    miles = Math.round(Math.floor(Number(inputValue) / transferRate) * transferRateMultipliers[partner]);
  }
  return miles;
};

const getTransferRateAndLabels = (formContainer, dataObject) => {
  const partner = dataObject?.partnerAirline || dataObject?.partnerHotel || dataObject?.partnerOther || dataObject.partnerAirlineY;
  /**
     * For TierCode R00 and R01 only
     * transfer rate changes based on partner as well as FTO tag
     */
  let { TierCode } = dataObject;
  if (TierCode === 'R00' || TierCode === 'R01') {
    TierCode += dataObject.ftoEnrollFlag === 'yes' ? 'FTO' : 'nonFTO';
  }
  return {
    transferRate: formContainer?.staticMetadata?.transferRatesAndLabels?.transferRates?.[TierCode]?.[partner],
    partnerLabel: formContainer?.staticMetadata?.transferRatesAndLabels?.partnerLabels?.[partner],
    partner,
  };
};

export const invokeCalculateTransferpoints = (props) => {
  const {
    value,
    dataObject,
    setFormSubmissionPayload,
    operation,
  } = props;

  const transferPointsValue = calculateTransferpoints(
    value,
    operation.transferRateMultipliers,
    { ...dataObject.formSubmissionPayload, ...dataObject.curPageValues }
  );
  if (transferPointsValue !== null) {
    setFormSubmissionPayload({
      ...dataObject?.formSubmissionPayload,
      ...{
        elemId: null,
        transferPointsValue,
      },
    });
  } else {
    delete dataObject?.formSubmissionPayload?.transferPointsValue;
    setFormSubmissionPayload({
      ...dataObject?.formSubmissionPayload,
      elemId: null,
    });
  }
};

export const invokeGetPartnerTransferRateandLabel = (props) => {
  const {
    value,
    dataObject,
    setFormSubmissionPayload,
    formContainer,
    fieldId,
  } = props;

  const { transferRate, partnerLabel, partner } = getTransferRateAndLabels(
    formContainer,
    {
      ...dataObject.formSubmissionPayload,
      [fieldId]: value,
    }
  );
  if (transferRate && partnerLabel) {
    setFormSubmissionPayload({
      ...dataObject?.formSubmissionPayload,
      ...{
        transferRate,
        partnerLabel,
        partner,
        [fieldId]: value,
        elemId: null,
      },
    });
  } else {
    delete dataObject?.formSubmissionPayload?.transferRate;
    delete dataObject?.formSubmissionPayload?.partnerLabel;
    delete dataObject?.formSubmissionPayload?.partner;
    setFormSubmissionPayload({
      ...dataObject?.formSubmissionPayload,
      elemId: null,
      [fieldId]: value,
    });
  }
};
/* eslint-enable max-len -- need */
